import { DocumentNode, gql } from '@apollo/client';
import { convertFromRaw } from 'draft-js';
import * as React from 'react';

import { Redraft } from '@/components/Redraft';

import { Description_EventFragment } from './graphql-types/Description_EventFragment';

import { Speakers } from './components/Speakers';
import { Sponsorships } from './components/Sponsorships';

export const Description: React.FC<{
  event: Description_EventFragment;
  isHtml: boolean;
}> & {
  eventFragment: DocumentNode;
} = ({ event, isHtml }) => {
  if (!event) {
    return null;
  }

  const descriptionText = event.description
    ? convertFromRaw(event.description).getPlainText()
    : '';
  const descriptionExists = descriptionText.length > 0;

  if (isHtml) {
    return (
      <>
        {event.bannerImage?.imageProxy ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={event.bannerImage.imageProxy} alt="banner" />
        ) : null}
        <h1>{event.name}</h1>
        <div>
          {descriptionExists ? (
            <Redraft rawDraftContentState={event.description} />
          ) : (
            event.shortDescription || ''
          )}
        </div>

        <Speakers event={event} isHtml={true} />
        <Sponsorships event={event} isHtml={true} />
      </>
    );
  } else {
    return (
      <>
        {event.name} <br />
        {descriptionExists ? descriptionText : event.shortDescription || ''}
        <br />
        <br />
        <Speakers event={event} isHtml={false} />
        <br />
        <Sponsorships event={event} isHtml={false} />
      </>
    );
  }
};

Description.eventFragment = gql`
  fragment Description_EventFragment on EventV2 {
    _id
    name
    shortDescription
    description
    bannerImage {
      _id
      imageProxy(input: { ar: "8:3", w: 1600, fit: "fill", fill: "blur" })
    }
    ...Sponsorships_EventFragment
    ...Speakers_EventFragment
  }
  ${Sponsorships.eventFragment}
  ${Speakers.eventFragment}
`;
